
//http://definitelytyped.org/
///<reference path="../../../node_modules/@types/jquery/index.d.ts" />

import * as $ from 'jquery';

//Import plugin like this:
//import * as mixitup from '../../../node_modules/mixitup/dist/mixitup.js';

import cookieLaw = require('./cookie-law');
import initContactForm = require('./contact-form');

$(document).ready(() => {
    initContactForm();
    cookieLaw();
    if ($('.page-header-container').length) {
        $('.main-navigation li .slideLink').on("click", function (e) {
            e.preventDefault();

            var thisItem = $(this);
            var id = thisItem.attr("data-section");

            $('html,body').animate({
                scrollTop: $("." + id).offset().top - $('.page-header-container').height()
            },
                800);
        })

        $('.USPButton').on("click", function (e) {
            e.preventDefault();

            $('html,body').animate({
                scrollTop: $(".contactSection").offset().top - $('.page-header-container').height()
            },
                800);
        })

        $('.logo').on("click", function (e) {
            e.preventDefault();
            $('html,body').animate({
                scrollTop: 0
            }, 800);
        })

        $('.openMenu').on("click", function (e) {
            e.preventDefault();
            $(this).toggleClass("open")
            $('.main-navigation li').toggleClass("show")

            $(".page-header").css("height", $('.page-header-container').height());
        })

            $(window).scroll(function () {
                if ($(window).scrollTop() > $(".page-header-container").offset().top) {
                    $(".page-header-container").addClass("fixed");
                }
                else if ($(window).scrollTop() < $(".splashSection").offset().top + $(".splashSection").outerHeight(true) - 5) {
                    $(".page-header-container").removeClass("fixed");
                }
            });
    }
});

//Preloader
$(window).on("load", function () {
    $('#preloader').fadeOut('slow', function () {
        $(this).remove();
    });
});



// WEBPACK FOOTER //
// ./ToxicVentures.Umbraco/Content/Ts/app.ts